import buildSyncMediaPrefetchLayers from '../../../../store/products/helpers/buildSyncMediaPrefetchLayers';
import { prefetchSyncMedia } from '../../../../store/products/prefetchSyncMedia';

export default function createSyncMediaPrefetchRunner({ dispatch, getLayerArgs }) {
  const inflight = new Map();

  const prefetchRecordStates = (recordStates) => {
    const layers = buildSyncMediaPrefetchLayers({
      ...getLayerArgs(),
      recordStates,
    });

    return Promise.all(layers.map((layer) => {
      if (inflight.has(layer.key)) {
        return inflight.get(layer.key);
      }

      const promise = dispatch(prefetchSyncMedia(layer)).unwrap();
      inflight.set(layer.key, promise);
      return promise;
    }));
  };

  return { prefetchRecordStates };
}
